<template>
  <vc-calendar
      :from-page.sync="page"
      :masks="{weekdays: 'WWW'}"
      :attributes="attributes"
      :is-expanded="true"
      @dayclick="$emit('dayclick', $event)"/>
</template>

<script>
import {DateTime} from "luxon";

const modeColors = {
  Single: 'green',
  Solo: 'blue',
  Parallel: 'orange'
}

export default {
  props: {
    selectedDate: Object,
    updated: Number
  },
  data() {
    return {
      month: DateTime.local().month,
      year: DateTime.local().year,
      operatingDays: []
    }
  },
  computed: {
    page: {
      get() {
        return {month: this.month, year: this.year}
      },
      set({month, year}) {
        this.month = month
        this.year = year
      }
    },
    attributes() {
      const attrs = this.operatingDays.map(od => ({
        dates: od.date,
        highlight: {
          color: modeColors[od.mode] || 'gray',
          fillMode: 'solid'
        }
      }))
      if (this.selectedDate) {
        attrs.push({
          highlight: true,
          dates: this.selectedDate.toString()
        })
      }
      return attrs
    }
  },
  watch: {
    page() {
      this.loadOperatingDays()
    },
    selectedDate(newDate) {
      if (newDate) {
        this.month = newDate.month
        this.year = newDate.year
      }
    },
    updated() {
      this.loadOperatingDays()
    }
  },
  methods: {
    loadOperatingDays() {
      this.$api.get(`/calendar/operating-days/${this.year}/${this.month}`)
          .then(response => this.operatingDays = response.data)
          .catch(err => this.handleError(err))
    }
  },
  mounted() {
    this.loadOperatingDays()
  }
}
</script>
